import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SearchState {
  query: string;
  results: any[];
  loading: boolean;
  error: string | null;
  filters: {
    category: string;
    location: string;
    priceRange: [number, number];
  };
}

const initialState: SearchState = {
  query: '',
  results: [],
  loading: false,
  error: null,
  filters: {
    category: '',
    location: '',
    priceRange: [0, 1000],
  },
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setQuery: (state, action: PayloadAction<string>) => {
      state.query = action.payload;
    },
    searchStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    searchSuccess: (state, action: PayloadAction<any[]>) => {
      state.loading = false;
      state.results = action.payload;
    },
    searchFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateFilters: (state, action: PayloadAction<Partial<SearchState['filters']>>) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearSearch: (state) => {
      state.query = '';
      state.results = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setQuery,
  searchStart,
  searchSuccess,
  searchFailure,
  updateFilters,
  clearSearch,
} = searchSlice.actions;

export default searchSlice.reducer;